export default __webpack_public_path__ + "static/media/clouds.453b995b.svg";